import VueCookies from "vue-cookies";
const UID = VueCookies.isKey("UID") ? VueCookies.get("UID") : null;
const LID = VueCookies.isKey("LID") ? VueCookies.get("LID") : null;
const TID = VueCookies.isKey("TID") ? VueCookies.get("TID") : null;
const MID = VueCookies.isKey("MID") ? VueCookies.get("MID") : null;
const ACTIVE = VueCookies.isKey("ACTIVE") ? VueCookies.get("ACTIVE") : null;

//Menu
export const menuItems = [
  {
    id: 0,
    icon: "icon-home",
    // icon: 'fa-house',
    label: "Tổng quan",
    link: "/dashboard",
    listPermission: ["NSH_REPORT_SUMMARY"],
  },
  {
    id: 1,
    icon: "icon-chart-bar",
    // icon: 'fa-chart-line',
    label: "Báo cáo",
    link: "/revenue-report",
    listPermission: ["NSH_REPORT_SELL", "NSH_REPORT_PARTNER"],
    subItems: [
      {
        id: 1,
        label: "Báo cáo bán hàng",
        link: "/revenue-report",
        parentId: 1,
        permission: "NSH_REPORT_SELL",
      },
      {
        id: 2,
        label: "Báo cáo khách hàng",
        link: "/revenue-customer",
        parentId: 1,
        permission: "NSH_REPORT_PARTNER",
      },
      {
        id: 3,
        label: "Báo cáo tài chính",
        link: "/revenue-financing",
        parentId: 1,
        // permission: "NSH_REPORT_PARTNER",
      },
    ],
  },
  {
    id: 2,
    icon: "icon-cash-register",
    // icon: 'fa-cash-register',
    label: "Bán hàng",
    link: "/pos",
    listPermission: ["NSH_ORDER_CREATE"],
  },
  {
    id: 7,
    icon: "icon-store",
    // icon: 'fa-store',
    label: "Gian hàng trực tuyến",
    link: "/store-merchant/product-list",
    listPermission: ["NSH_ONLINE_STORE_VIEW", "NSH_ONLINE_STORE_SETTING"],
  },
  {
    id: 3,
    icon: "icon-logistics-box",
    // icon: 'fa-clipboard-list',
    label: "Đơn hàng",
    link: "/orders",
    listPermission: ["NSH_ORDER_VIEW", "NSH_ORDER_RETURN"],
    subItems: [
      {
        id: 1,
        label: "Danh sách đơn hàng",
        link: "/orders",
        parentId: 3,
        permission: "NSH_ORDER_VIEW"
      },
      {
        id: 2,
        label: "Danh sách trả hàng",
        link: "/orders/orders-return",
        parentId: 3,
        permission: "NSH_ORDER_RETURN"
      }
    ]
  },
  {
    id: 4,
    icon: "icon-logistics-box",
    // icon: 'fa-clipboard-list',
    label: "Giao hàng",
    link: "/orders-delivery",
    listPermission: ["NSH_ORDER_VIEW", "NSH_ORDER_RETURN"],
    subItems: [
      {
        id: 1,
        label: "Danh sách đơn giao hàng",
        link: "/orders-delivery/delivery-orders-list",
        parentId: 4,
        permission: "NSH_ORDER_VIEW"
      },
      {
        id: 2,
        label: "Đối tác giao hàng",
        link: "/orders-delivery/delivery-partners",
        parentId: 4,
        // permission: "NSH_ORDER_RETURN"
      }
    ]
  },
  {
    id: 6,
    icon: "icon-order",
    // icon: 'fa-tags',
    label: "Sản phẩm",
    link: "/items",
    listPermission: [
      "NSH_ITEM_PROD_VIEW",
      "NSH_ITEM_CATEG_VIEW",
      "NSH_ITEM_TYPE_VIEW",
      "NSH_ITEM_PROD_CREATE",
    ],
    subItems: [
      {
        id: 1,
        label: "Danh sách sản phẩm",
        link: "/items",
        parentId: 6,
        permission: "NSH_ITEM_PROD_VIEW",
      },
      {
        id: 2,
        label: "Danh mục sản phẩm",
        link: "/items/category",
        parentId: 6,
        permission: "NSH_ITEM_CATEG_VIEW",
      },
      {
        id: 3,
        label: "Đơn vị tính",
        link: "/items/unit",
        parentId: 6,
        permission: "NSH_ITEM_PROD_CREATE",
      },
      {
        id: 4,
        label: "Thương hiệu",
        link: "/items/brand",
        parentId: 6,
        permission: "NSH_ITEM_PROD_CREATE",
      },
      {
        id: 5,
        label: "Chính sách bảo hành",
        link: "/items/warranty",
        parentId: 6,
        permission: "NSH_ITEM_PROD_CREATE",
      },
      {
        id: 6,
        label: "In mã vạch",
        link: "/barcode/choose",
        parentId: 6,
        permission: "NSH_ITEM_PROD_CREATE",
      },
    ],
  },
  {
    id: 10,
    icon: "icon-logistics-box",
    // icon: 'fa-box',
    label: "Kho & Tồn",
    link: "/inventory-list",
    listPermission: ['NSH_INV_VIEW', 'NSH_MCMNT_MERCHANT_UPDATE', 'NSH_INV_ITEM_VIEW', 'NSH_ODM_IO_VIEW'],
    subItems: [
      {
        id: 1,
        label: "Quản lý kho",
        link: "/inventory-list",
        parentId: 10,
        permission: "NSH_INV_VIEW",
      },
      {
        id: 2,
        label: "Tồn kho",
        link: "/inventory-detail",
        parentId: 10,
        permission: "NSH_INV_ITEM_VIEW",
      },
      // {
      //   id: 4,
      //   label: "Cài đặt kho",
      //   link: "/inventory-setting",
      //   parentId: 10,
      //   permission: 'NSH_MCMNT_MERCHANT_UPDATE'
      // },
      {
        id: 5,
        label: "Nhập kho",
        link: "/inventory-checkin",
        parentId: 10,
        permission: 'NSH_ODM_IO_VIEW'
      },
      {
        id: 6,
        label: "Xuất kho",
        link: "/inventory-checkout",
        parentId: 10,
        permission: 'NSH_ODM_CO_VIEW'
      },
      {
        id: 7,
        label: "Chuyển kho",
        link: "/inventory-trans",
        parentId: 10,
        permission: 'NSH_ODM_TF_VIEW'
      },
    ],
  },
  {
    id: 5,
    icon: "bx bx-money",
    // icon: 'fa-credit-card',
    label: "Ứng vốn",
    href: `https://nextlend.vn/`,
    listPermission: [],
  },
  {
    id: 4,
    icon: "icon-debt-note",
    // icon: 'fa-money-check-dollar',
    label: "Sổ công nợ",
    link: "/debt_list",
    listPermission: ["NSH_DEBT_VIEW"],
    subItems: [
      {
        id: 1,
        label: "Khoản phải thu",
        link: "/debtList_recovery",
        parentId: 4,
        permission: "NSH_DEBT_VIEW",
      },
      {
        id: 2,
        label: "Khoản phải trả",
        link: "/debtList_repay",
        parentId: 4,
        permission: "NSH_DEBT_VIEW",
      },
      {
        id: 3,
        label: "Khoản đã hoàn thành",
        link: "/debtList_accomplished",
        parentId: 4,
        permission: "NSH_DEBT_VIEW",
      },
    ],
  },
  {
    id: 8,
    icon: "icon-customer",
    // icon: 'fa-users-rectangle',
    label: "Khách hàng",
    link: "/customer-list",
    listPermission: ["NSH_PARTNER_CUS_VIEW", "NSH_PARTNER_GROUP_CUS_VIEW"],
    subItems: [
      {
        id: 1,
        label: "Quản lý khách hàng",
        link: "/customer-list",
        parentId: 8,
        permission: "NSH_PARTNER_CUS_VIEW",
      },
      {
        id: 2,
        label: "Quản lý nhóm khách hàng",
        link: "/group-customer",
        parentId: 8,
        permission: "NSH_PARTNER_GROUP_CUS_VIEW",
      },
    ],
  },
  {
    id: 11,
    icon: "icon-supplier",
    // icon: 'fa-warehouse',
    label: "Nhà cung cấp",
    link: "/group-supplier",
    listPermission: ["NSH_PARTNER_SUP_VIEW", "NSH_PARTNER_GROUP_SUP_VIEW"],
    subItems: [
      {
        id: 1,
        label: "Danh sách nhà cung cấp",
        link: "/supplier-list",
        parentId: 10,
        permission: "NSH_PARTNER_SUP_VIEW",
      },
      {
        id: 2,
        label: "Nhóm nhà cung cấp",
        link: "/group-supplier",
        parentId: 10,
        permission: "NSH_PARTNER_GROUP_SUP_VIEW",
      },
    ],
  },
  {
    id: 9,
    icon: "icon-staff",
    // icon: 'fa-clipboard-user',
    label: "Nhân viên",
    link: "/employee-list",
    listPermission: ["NSH_MCMNT_ALIAS_VIEW", "NSH_IAM_ROLE_VIEW"],
    subItems: [
      {
        id: 1,
        label: "Danh sách nhân viên",
        link: "/employee-list",
        parentId: 9,
        permission: "NSH_MCMNT_ALIAS_VIEW",
      },
      {
        id: 2,
        label: "Phân quyền vai trò",
        link: "/role",
        parentId: 9,
        permission: "NSH_IAM_ROLE_VIEW",
      },
    ],
  },
  {
    id: 12,
    icon: "icon-cog",
    label: "Cấu hình",
    link: "/setting",
    listPermission: ['NSH_CFG_MC']
  }
]

  export const menuFooterItems = [
  {
    id: 12,
    // icon: "icon-cog",
    icon: 'fa-gear',
    label: "Cấu hình",
    link: "/setting",
    listPermission: ["NSH_CFG_MC"],
  },
  // {
  //   id: 13,
  //   icon: "icon-cog",
  //   label: "Đồng bộ",
  //   href: `${process.env.VUE_APP_NEXT360_URL}/login_app?np_merchant_id=${MID}&np_user_id=${UID}&np_location_id=${LID}&np_app_id=${process.env.VUE_APP_ID}&token=${TID}`
  // },
  // {
  //   id: 14,
  //   icon: "icon-comment-check",
  //   label: "Góp ý",
  //   link: "/dashboard"
  // }
];

export const menuItems2 = [
  {
    id: 0,
    icon: 'fa-house',
    label: "Tổng quan",
    link: "/dashboard",
    isOpen: false,
    listPermission: ["NSH_REPORT_SUMMARY"],
  },
  {
    id: 1,
    icon: 'fa-chart-line',
    label: "Báo cáo",
    link: "/revenue-report",
    listPermission: ["NSH_REPORT_SELL", "NSH_REPORT_PARTNER"],
    isOpen: false,
    subItems: [
      {
        id: 1,
        label: "Báo cáo bán hàng",
        link: "/revenue-report",
        parentId: 1,
        permission: "NSH_REPORT_SELL",
      },
      {
        id: 2,
        label: "Báo cáo khách hàng",
        link: "/revenue-customer",
        parentId: 1,
        permission: "NSH_REPORT_PARTNER",
      },
    ],
  },
  {
    id: 2,
    icon: 'fa-cash-register',
    label: "Bán hàng",
    link: "/pos",
    listPermission: ["NSH_ORDER_CREATE"],
    isOpen: false,
  },
  {
    id: 3,
    icon: 'fa-store',
    label: "Gian hàng trực tuyến",
    link: "/store-merchant/product-list",
    listPermission: ["NSH_ONLINE_STORE_VIEW", "NSH_ONLINE_STORE_SETTING"],
    isOpen: false,
  },
  {
    id: 4,
    icon: 'fa-clipboard-list',
    label: "Đơn hàng",
    link: "/orders",
    listPermission: ["NSH_ORDER_VIEW"],
    isOpen: false,
  },
  {
    id: 5,
    icon: 'fa-tags',
    label: "Sản phẩm",
    link: "/items",
    listPermission: [
      "NSH_ITEM_PROD_VIEW",
      "NSH_ITEM_CATEG_VIEW",
      "NSH_ITEM_TYPE_VIEW",
      "NSH_ITEM_PROD_CREATE",
    ],
    isOpen: false,
    subItems: [
      {
        id: 1,
        label: "Danh sách sản phẩm",
        link: "/items",
        parentId: 6,
        permission: "NSH_ITEM_PROD_VIEW",
      },
      {
        id: 7,
        label: "Lô - HSD",
        link: "items/batch",
        parentId: 5,
      },
      {
        id: 2,
        label: "Danh mục sản phẩm",
        link: "/items/category",
        parentId: 6,
        permission: "NSH_ITEM_CATEG_VIEW",
      },
      {
        id: 3,
        label: "Đơn vị tính",
        link: "/items/unit",
        parentId: 6,
        permission: "NSH_ITEM_PROD_CREATE",
      },
      {
        id: 4,
        label: "Thương hiệu",
        link: "/items/brand",
        parentId: 6,
        permission: "NSH_ITEM_PROD_CREATE",
      },
      {
        id: 5,
        label: "Chính sách bảo hành",
        link: "/items/warranty",
        parentId: 6,
        permission: "NSH_ITEM_PROD_CREATE",
      },
      {
        id: 6,
        label: "In mã vạch",
        link: "/barcode/choose",
        parentId: 6,
        permission: "NSH_ITEM_PROD_CREATE",
      },
    ],
  },
  {
    id: 6,
    icon: 'fa-box',
    label: "Kho & Tồn",
    link: "/inventory-list",
    listPermission: ['NSH_INV_VIEW', 'NSH_MCMNT_MERCHANT_UPDATE', 'NSH_INV_ITEM_VIEW',
     'NSH_ODM_IO_VIEW'],
    isOpen: false,
    subItems: [
      {
        id: 1,
        label: "Quản lý kho",
        link: "/inventory-list",
        parentId: 10,
        permission: "NSH_INV_VIEW",
      },
      {
        id: 2,
        label: "Tồn kho",
        link: "/inventory-detail",
        parentId: 10,
        permission: "NSH_INV_ITEM_VIEW",
      },
      // {
      //   id: 4,
      //   label: "Cài đặt kho",
      //   link: "/inventory-setting",
      //   parentId: 10,
      //   permission: 'NSH_MCMNT_MERCHANT_UPDATE'
      // },
      {
        id: 5,
        label: "Nhập kho",
        link: "/inventory-checkin",
        parentId: 10,
        permission: 'NSH_ODM_IO_VIEW'
      },
      {
        id: 6,
        label: "Xuất kho",
        link: "/inventory-checkout",
        parentId: 10,
        permission: 'NSH_ODM_CO_VIEW'
      },
      {
        id: 7,
        label: "Chuyển kho",
        link: "/inventory-trans",
        parentId: 10,
        permission: 'NSH_ODM_TF_VIEW'
      },
    ],
  },
  {
    id: 7,
    icon: 'fa-credit-card',
    label: "Ứng vốn",
    href: `https://nextlend.vn/`,
    listPermission: [],
  },
  {
    id: 8,
    icon: 'fa-money-check-dollar',
    label: "Sổ công nợ",
    link: "/debt_list",
    listPermission: ["NSH_DEBT_VIEW"],
    isOpen: false,
    subItems: [
      {
        id: 1,
        label: "Khoản phải thu",
        link: "/debtList_recovery",
        parentId: 4,
        permission: "NSH_DEBT_VIEW",
      },
      {
        id: 2,
        label: "Khoản phải trả",
        link: "/debtList_repay",
        parentId: 4,
        permission: "NSH_DEBT_VIEW",
      },
      {
        id: 3,
        label: "Khoản đã hoàn thành",
        link: "/debtList_accomplished",
        parentId: 4,
        permission: "NSH_DEBT_VIEW",
      },
    ],
  },
  {
    id: 9,
    icon: 'fa-users-rectangle',
    label: "Khách hàng",
    link: "/customer-list",
    listPermission: ["NSH_PARTNER_CUS_VIEW", "NSH_PARTNER_GROUP_CUS_VIEW"],
    isOpen: false,
    subItems: [
      {
        id: 1,
        label: "Quản lý khách hàng",
        link: "/customer-list",
        parentId: 8,
        permission: "NSH_PARTNER_CUS_VIEW",
      },
      {
        id: 2,
        label: "Quản lý nhóm khách hàng",
        link: "/group-customer",
        parentId: 8,
        permission: "NSH_PARTNER_GROUP_CUS_VIEW",
      },
    ],
  },
  {
    id: 10,
    icon: 'fa-warehouse',
    label: "Nhà cung cấp",
    link: "/group-supplier",
    listPermission: ["NSH_PARTNER_SUP_VIEW", "NSH_PARTNER_GROUP_SUP_VIEW"],
    isOpen: false,
    subItems: [
      {
        id: 1,
        label: "Danh sách nhà cung cấp",
        link: "/supplier-list",
        parentId: 10,
        permission: "NSH_PARTNER_SUP_VIEW",
      },
      {
        id: 2,
        label: "Nhóm nhà cung cấp",
        link: "/group-supplier",
        parentId: 10,
        permission: "NSH_PARTNER_GROUP_SUP_VIEW",
      },
    ],
  },
  {
    id: 11,
    icon: 'fa-clipboard-user',
    label: "Nhân viên",
    link: "/employee-list",
    listPermission: ["NSH_MCMNT_ALIAS_VIEW", "NSH_IAM_ROLE_VIEW"],
    isOpen: false,
    subItems: [
      {
        id: 1,
        label: "Danh sách nhân viên",
        link: "/employee-list",
        parentId: 9,
        permission: "NSH_MCMNT_ALIAS_VIEW",
      },
      {
        id: 2,
        label: "Phân quyền vai trò",
        link: "/role",
        parentId: 9,
        permission: "NSH_IAM_ROLE_VIEW",
      },
    ],
  },
]

  export const menuFooterItems2 = [
  {
    id: 12,
    icon: 'fa-gear',
    label: "Cấu hình",
    link: "/setting",
    listPermission: ["NSH_CFG_MC"],
  },
];
